import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { DropdownMultiSelect } from 'rhinostyle';
import { shapeRolePermissions } from '../helpers/RoleHelpers';

const SystemRolesDropdown = ({
  disabled,
  value: selectedIds,
  handleChange,
}) => {
  const roles = useSelector((state) => [...shapeRolePermissions(state.role.systemRoles), ...shapeRolePermissions(state.role.customRoles)]);
  const systemRoles = roles.filter((role) => role.systemRole);
  const items = systemRoles.reduce((acc, role) => {
    const roleId = role.id;
    acc[roleId] = {
      ...role,
      title: role.name,
      label: role.name,
    };
    return acc;
  }, {});
  const itemIds = Object.keys(items);

  function getDropdownLabel() {
    if (selectedIds.length > 0) {
      return selectedIds.map((tagId) => `#${items[tagId].name}`).join(', ');
    }
    return 'System Roles';
  }

  function handleSelectItem(name, value) {
    // remove from array if present, otherwise add
    const updatedRoles = selectedIds.includes(value) ? selectedIds.filter((id) => id !== value) : [...selectedIds, value];
    handleChange('systemRoles', updatedRoles);
  }

  return itemIds?.length > 0 ? (

    <DropdownMultiSelect
      items={items}
      itemIds={itemIds}
      selectedItemIds={selectedIds}
      handleSelect={handleSelectItem}
      label={getDropdownLabel()}
      name="systemRoles"
      dropdownClass="filter-page__dropdown filter-page__dropdown--wide"
      disabled={disabled}
    />
  ) : null;
};
SystemRolesDropdown.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,

};
export default SystemRolesDropdown;
